<template>
  <div class="address-wrap" @click.stop="">
    <span>配送至：</span>
    <div v-if="address && address.receiverName" class="adressBox">
      <div v-if="address.isDefault" class="defTab">
        默认
      </div>
      <div class="item">
        {{ address.receiverName }}
      </div>
      <div class="item">
        {{ address.province }}
      </div>
      <div class="item">
        {{ address.city }}
      </div>
      <div class="item">
        {{ address.county }}
      </div>
      <div class="item">
        {{ address.receiptAddress }}
      </div>
      <div class="item">
        {{ address.receiverPhone }}
      </div>
    </div>
    <el-button v-if="address && address.receiverName" type="text" class="btn-wrap" @click.stop="isShow = true">
      更改地址
    </el-button>
    <el-button v-else type="text" class="btn-wrap" @click.stop="isShow=true">
      选择地址
    </el-button>

    <addressBox :prop-open.sync="isShow" @chooseAddress="changeAddress" @ChangeDatas="changeDatas" />
  </div>
</template>

<script>
import addressBox from '@/views/address/index.vue';
import { getReceiptAddressInfoModel } from '@/API';

export default {
  components: {
    addressBox
  },

  data () {
    return {
      isShow: false,
      address: {}
    };
  },

  methods: {
    // 地址变更回到
    changeAddress (val) {
      // 选择其他地址
      this.address = val;
      this.isShow = false;
      this.$emit('chooseAddress', val);
    },

    // 地址选择 地址源地址列表发生变化，需要用当前地址id 重新查询地址信息
    changeDatas () {
      if (this.address.id) {
        getReceiptAddressInfoModel(this.address.id).then((res) => {
          let { status, data } = res.data;
          if (status === '200') {
            if (!data.isDelete) {
              this.address = data;
            } else {
              this.address = {};
            }
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.address-wrap{
  display: inline-block;
}

.adressBox{
  display: inline-block;

  .item{
    display: inline-block;
    margin-right: 6px;
  }

  .defTab{
    padding: 3px 10px;
    display: inline-block;
    background: #1b73ff;
    font-size: 12px;
    color: #fff;
    border-radius: 4px;
    margin-right: 15px;
  }
}

.btn-wrap{
  padding: 0;
  margin-left: 15px
}
</style>
